<template>
  <div class="tab-content">
    <div class="mb-4">
      <div>
        <label for="uploadImg" class="upload-label">Загрузить фото</label>
        <input
          id="uploadImg"
          ref="fileInput"
          type="file"
          class="file-input"
          accept="image/x-png,image/jpg,image/jpeg"
          @input="$emit('file-picked', $event)"
        />
      </div>
      <div class="photos-row mb-4">
        <div v-for="(image, imageIndex) in productPhotos" :key="imageIndex" class="photo">
          <div
            class="image"
            :style="{
              backgroundImage: 'url(' + image.url + ')',
              width: '200px',
              height: '200px',
              display: 'inline-flex',
            }"
            @click.stop="$emit('open-gallery', imageIndex)"
          />
          <va-button color="danger" class="mr-4" @click.prevent="$emit('delete-photo', imageIndex)">
            Удалить
          </va-button>
        </div>
      </div>
      <div
        v-if="errors.photos"
        class="error-message"
        style="margin-top: 8px; padding: 8px; border: 1px solid #ff4444; border-radius: 4px; background: #fff5f5;"
      >
        Загрузите пожалуйста фото
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductFormTabPhotos",
  props: {
    productPhotos: { type: Array, default: () => [] },
    errors: { type: Object, default: () => ({}) },
  },
};
</script>

<style scoped>
.tab-content {
  grid-column: 1 / -1;
}
.image {
  cursor: pointer;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 2px solid #6d6d6d;
  border-radius: 11px;
  margin-right: 20px;
}
.photos-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
  padding-bottom: 30px;
}
.photo {
  display: flex;
  flex-direction: column;
}
.upload-label {
  display: block;
  background-color: #5cb85c;
  padding: 5px;
  border-radius: 7px;
  text-align: center;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
  margin-bottom: 30px;
}
.error-message {
  color: #ff4444;
  font-size: 0.875rem;
  margin-top: 4px;
}
</style>
